/**
 * Elevation sorting utilities for Native ISM.
 *
 * Normalizes and sorts elevations by display order first, then title as a stable tie-breaker.
 *
 * @module nativeInteractiveSiteMap/services/elevationSortService
 */

function normalizeText(value) {
  return String(value || '').trim();
}

/**
 * @param {Array} elevations
 * @returns {Array<{id: string, title: string, description: string, url: string|null, displayOrder: number|undefined}>}
 */
export default function sortElevations(elevations = []) {
  const elevationList = Array.isArray(elevations) ? elevations : [];

  return elevationList
    .map((elevation, index) => ({
      id: elevation.id || String(index),
      title: normalizeText(elevation?.title || String(index + 1)),
      description: normalizeText(elevation?.description),
      url: elevation?.url || null,
      displayOrder: elevation?.displayOrder,
    }))
    .sort((a, b) => {
      const aOrder = Number.isFinite(a.displayOrder) ? a.displayOrder : Number.MAX_SAFE_INTEGER;
      const bOrder = Number.isFinite(b.displayOrder) ? b.displayOrder : Number.MAX_SAFE_INTEGER;

      if (aOrder !== bOrder) {
        return aOrder - bOrder;
      }

      return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
    });
}